export const endPoints = {
  login: '/auth/login',
  refreshSession: '/auth/refresh',
  loginAsAdmin: '/auth/login-as-admin',
  loginAsAgency: '/auth/login-as-agency',
  loginAsEmployee: '/auth/login-as-subcontractor',
  loginAsByParentCompany: '/auth/login-as-user-by-parent-company',
  signup: '/auth/bureau/signup',
  appConfigs: '/app-configs',
  getMe: '/me',
  getPolicies: '/me/policies',
  getMyActions: '/me/actions',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/verify-email',
  getCompany: '/company',
  deleteCompany: '/company',
  bureauSettings: '/users',
  logoutSupperAdmin: '/auth/logout-as-superadmin',
  switchCountry: '/auth/login/country',
  oauth: '/oauth/authorize',
  encrypt: '/auth/encrypt',
  company: {
    index: '/company',
    timesheetValue: '/timesheet-values/company',
    getList: '/company',
    search: '/company/search',
    create: '/company',
    createV2: '/v2/company',
    createDraft: '/company-draft',
    update: '/company',
    getDetail: '/company',
    getEmailTemplate: '/email-template/company',
    updateEmailTemplate: '/email-template',
    getConnectPensionLink: '/company',
    testEmail: '/company/send/test-email',
    testEmailV2: '/v2/company/send/test-email',
    companiesTimesheet: '/time-sheet/companies-timesheet',
    expense: (id: string) => `/company/${id}/expenses`,
    connectSmartPension: (id: string) =>
      `/company/${id}/auth-smart-pension-link`,
    connectSmartPensionDraft: (id: number) =>
      `/company-draft/${id}/smart-pension/pre-authorize`,
    pensionStatusDraft: (id: number) => `/company-draft/${id}/pension/status`,
    sendLinkDraft: (id: number) => `/company-draft/${id}/send-link`,
    disconnectSmartPension: (id: string) =>
      `/company/${id}/disconnect-smart-pension`,
    connectNestPension: (id: string) => `/company/${id}/connect-pension`,
    connectNestPensionDraft: (id: number) =>
      `/company-draft/${id}/nest/connect`,
    nestSettings: (id: string) => `/company/${id}/nest-settings`,
    disconnectNestPension: (id: string) => `/company/${id}/disconnect-pension`,
    zohoSettings: (id: string) => `/company/${id}/zoho-settings`,
    xeroSettings: (id: string) => `/company/${id}/xero-settings`,
    connectZoho: (id: string) => `/company/${id}/zoho-grant-token-url`,
    zohoTemplates: (id: string) => `/company/${id}/zoho-templates`,
    zohoTemplateDetails: (id: string, templateId: string) =>
      `/company/${id}/zoho-templates/${templateId}`,
    safeRecSettings: (id: string) => `/company/${id}/safe-rec-settings`,
    boostworksSettings: (id: string) => `/company/${id}/bootswork-setting`,
    veriPayeSettings: (id: string) => `/company/${id}/veriPaye-setting`,
    activityLog: '/activity-log/company',
    workingPattern: '/company/working-pattern-setting',
    isAssignedDepartment: '/department/is-assigned',
    privateIrelandPension: (id: string) =>
      `/company/${id}/ireland-private-pension`,
    toggleDefaultPrivateIrelandPension: (id: string, settingId: number) =>
      `/company/${id}/ireland-private-pension/${settingId}/toggle-default`,
    updateCompany: (id: string) => `/company/${id}`,
  },
  employee: {
    get: '/subcontractor',
    verify: '/subcontractor/cis-verify',
    update: '/subcontractor',
    exportExcel: '/subcontractor/export',
    exportAllSubcontractorV2: '/v2/subcontractor/export',
    getBank: '/subcontractor/bank',
    updateBank: '/subcontractor/bank',
    payrollSetting: '/subcontractor/setting',
    timesheetValue: '/timesheet-values/subcontractor',
    document: '/subcontractor/document',
    note: '/subcontractor/note',
    paymentsSetting: '/subcontractor/payment',
    deductionSetting: '/subcontractor/deduction',
    deductionSettingIreland: '/subcontractor/deduction/ireland',
    timesheet: '/subcontractor/time-sheets',
    selfBill: '/subcontractor/self-bill',
    viewPdfSelfBillView: '/subcontractor/self-bill/pdf-viewer',
    exportPdfSelfBill: '/subcontractor/self-bill/export-pdf',
    getSelfBillDetail: (selfBillId: string) =>
      `/subcontractor/self-bill/${selfBillId}/detail`,
    message: '/subcontractor/message',
    adminNewMessage: '/subcontractor/message/admin/new-message',
    pension: '/subcontractor/pension',
    listApprover: '/draft-payroll/request-users',
    getListApprover: (id: string) => `/draft-payroll/${id}/request-users`,
    newListApprover: '/draft-payroll',
    sendOnboarding: '/subcontractor/onboarding/invite',
    rpn: '/rpn',
    irelandPrivatePension: (subcontractorId: string) =>
      `/subcontractor/${subcontractorId}/ireland-private-pension`,
    createEmployee: '/subcontractor/bureau',
    bik: '/bik',
    getV2: '/v2/subcontractor',
    exportExcelV2: '/v2/subcontractor/export',
    resendLoginId: '/subcontractor/login-id/resend-email',
    fetchSmartPensionByCompanyId:
      '/pensions/smart-pension/fetch-smart-pension-by-company',
    fetchSmartPensionByEmployeeId:
      '/pensions/smart-pension/fetch-smart-pension-by-employee',
    onHold: (id: string) => `/subcontractor/${id}/on-hold`,
    holidayPay: (id: string) => `/subcontractor/${id}/holiday-pays`,
    ytdHistory: '/ytd-history',
    leaverHistory: (id: string) =>
      `/subcontractor/setting/${id}/history-leaver`,
    downloadLatestHistoryLeaver: (id: string) =>
      `/subcontractor/setting/${id}/download-latest-history-leaver`,
    downloadP60: (id: string) => `/subcontractor/${id}/issue-p60`,
    sendEmailP60: (id: string) => `/subcontractor/${id}/issue-p60/send-email`,
    assignment: '/subcontractor/assignments',
    expense: '/subcontractor/expenses',
    ytdValues: (id: string) => `/subcontractor/${id}/ytdValues`,
    expensePot: (id: string) => `/subcontractor/expenses/${id}/expense-pot`,
    submitExpense: '/subcontractor/expenses/opening-balance',
    delete: '/subcontractor/delete',
    reinstatement: (id: string) =>
      `/subcontractor/setting/${id}/re-instatement`,
    upcomingPayment: (id: string) => `/subcontractor/${id}/upcoming-payment`,
    payBreakdown: '/subcontractor/pay-breakdown',
    timesheetBreakdown: '/subcontractor/time-sheet-breakdown',
    allPayrollsTaxPeriodTaxYear:
      '/subcontractor/all-payrolls-tax-period-tax-year',
  },
  // NX-6284: Ireland 8% of worked hours (irregular) holiday pay.
  irregularHoliday: {
    workerSummary: (id: string) => `/irregular-holiday/workers/${id}`,
    // Guarded by `timesheets:create` (narrower than workerSummary's
    // payroll-settings permission) — the only one TimesheetForm/AppRateForm
    // may call, since an agency contact or Timesheets-only company user can
    // reach it but not GET /workers/:id.
    timesheetView: (id: string) =>
      `/irregular-holiday/workers/${id}/timesheet-view`,
    openingBalances: (id: string) =>
      `/irregular-holiday/workers/${id}/opening-balances`,
  },
  activityLog: {
    subcontractor: '/activity-log/subcontractor',
    agency: '/activity-log/agency',
    company: '/activity-log/company',
  },
  emailLog: {
    subcontractor: '/email-log/subcontractor',
  },
  uploadFile: '/aws',
  getBankList: '/bank-name',
  agency: {
    main: '/agency',
    createV2: '/v2/agency',
    contact: '/agency/contact',
    timesheetValue: '/timesheet-values/agency',
    deleteTimesheetValue: '/timesheet-values',
    document: '/agency/document',
  },
  paymentRate: {
    main: '/payment-rate',
    vatCode: '/vat-code',
  },
  dashboard: {
    main: '/dashboard',
    statistics: {
      timesheets: '/dashboard/statistics/timesheets',
      invoicing: '/dashboard/statistics/invoicing',
      payments: '/dashboard/statistics/payments',
      subcontractorsAssignments:
        '/dashboard/statistics/subcontractors-assignments',
      onHold: '/dashboard/statistics/on-hold',
      pensions: '/dashboard/statistics/pensions',
      pensionSubcontractors: '/dashboard/statistics/pension-subcontractors',
      others: '/dashboard/statistics/others',
      miscellaneous: '/dashboard/statistics/miscellaneous',
      payrollImports: '/dashboard/statistics/payroll-imports',
      communication: '/dashboard/statistics/communication',
      rtiSubmissions: '/dashboard/statistics/rti-submissions',
      clientApprovalRejection:
        '/dashboard/statistics/client-approval-and-rejection',
      employees: '/dashboard/ire-land/statistics/employees',
      payrollImportsIreland: '/dashboard/ire-land/statistics/payroll-imports',
      submitPSR: '/dashboard/ire-land/statistics/submit-psr',
      compliance: '/dashboard/statistics/compliance',
    },
    confirmPayment: '/payroll/confirm-payrolls-run-job',
    payment: '/dashboard/payments',
    paymentEPS: '/dashboard/eps-pre-submit',
    subcontractor: '/dashboard/subcontractors',
    invoices: '/dashboard/invoices',
    onHoldTimeSheet: '/dashboard/on-hold-timesheets',
    getPaymentNotConfirm: '/payroll/confirm-excel/all',
    assignment: '/dashboard/assignments',
    requiredAlerts: '/v2/dashboard/required-alerts',
    requiredAlertsList: '/v2/dashboard/required-alerts/list',
    agency: '/dashboard/all/agency',
    agencyPortal: {
      subcontractor: '/dashboard/subcontractor/agency',
      payment: '/dashboard/payment/agency',
      timesheets: '/agency/time-sheets',
    },
    subcontractorPortal: {
      assignment: '/dashboard/subcontractor/assignments',
      document: (subcontractorId: string) =>
        `/subcontractor/document/${subcontractorId}`,
      timeSheet: '/dashboard/subcontractor/time-sheets',
      awaitingPayment: '/dashboard/subcontractor/awaiting-payments',
      general: '/dashboard/subcontractor/all',
      awaitingPaymentAndDocument:
        '/dashboard/employee-portal/statistics/miscellaneous',
      newAwatingPayment: '/subcontractor/time-sheets',
      documentNew: '/subcontractor/document',
      pensionContribution: (subcontractorId: string) =>
        `/subcontractor/pension/${subcontractorId}`,
    },
    cisSubmitted: '/cis-submitted',
    maskAsSubmitted: '/cis-submitted/mark-as-submitted',
    epsSubmitted: '/hmrc-submitted/eps',
    epsSaveCisDeductionsSuffered: '/company',
    fpsSubmitted: '/hmrc-submitted/fps',
    generatePaymentFile: '/payroll/confirm-payrolls/by-company-id',
    payroll: {
      confirmPayroll: '/payroll',
      errorDraftPayroll: '/draft-payroll',
    },
    companyPaymentGrouping: '/subcontractor/company-payment-grouping',
    timesheetGrouping: '/time-sheet/grouping-by-company',
    payrollGroupingByPeriodAndFrequency:
      '/payroll/grouping-by-period-frequency',
    submitCISDeductionsSuffered: (id: string) =>
      `/company/${id}/cis-deductions-suffered`,
  },
  timesheet: {
    main: '/time-sheet',
    bureauTimesheet: '/bureau/time-sheet',
    statistics: '/dashboard/statistics/timesheets',
    invoice: '/time-sheet/invoiced/time-sheet',
    approval: '/time-sheet/approve/time-sheet',
    assignments: '/subcontractor/assignments',
    disable: '/time-sheet/disable-enable/time-sheet',
    groupingList: '/bureau/time-sheet/grouping',
    saveRunPayroll: '/bureau/time-sheet/save-run-payroll',
    employeeHaveTimesheet: '/bureau/time-sheet/employee-list',
    companyHaveTimesheet: '/bureau/time-sheet/company-list',
    cancel: '/time-sheet/cancel/time-sheet',
    groupingTimesheets: '/time-sheet/grouping',
    taxPeriod: (id: string) => `/time-sheet/${id}/tax-period`,
    bulkTaxPeriod: '/time-sheet/bulk/tax-period',
    imports: '/time-sheet/imports',
  },
  user: {
    admin: '/users/admin',
    changePassword: '/users/change-password',
    listUser: '/users/all/users-list',
    adminCreate: '/users/admin/create-new-user',
    acceptReject: '/users/update/status-user',
    blockUnblock: '/users/update/block-user',
    superAdminCreate: '/users/super-admin/create-new-admin-user',
    superAdminCreateEmployer: '/users/super-admin/create-employer-account',
    subcontractors: '/users/subcontractors',
    agencies: '/users/agencies',
  },
  backOffice: {
    main: '/back-office',
  },
  attachmentOrder: {
    main: '/attachment-order',
  },
  draftPayroll: {
    main: '/draft-payroll',
    // NX-6289: email draft payslips before the bank file.
    email: '/draft-payroll/send-email-payslips',
  },
  payroll: {
    main: '/payroll',
    paymentSummary: '/report/payment-summary',
    export: '/payroll/export-excel/all',
    email: '/payroll/send-email/subcontractor-self-bill',
    emailManually: '/payroll/send-email/self-bill',
    downloadAll: '/download-all/payrolls',
    draft: '/draft-payroll',
    downloadAllDraft: '/download-all/draft-payrolls',
    holidayPay: '/holiday-pays',
    pensionExpense: '/payroll/reports',
    dormantWorker: '/subcontractor/dormant-worker-report',
    netPay: '/breakdown-payrolls',
    disable: '/time-sheet/disable-enable/time-sheet',
    draftPayrollSalary: '/draft-payroll/salary',
    safeRec: '/payroll/safe-rec',
    safeRecErrors: '/payroll/safe-rec/errors',
    safeRecRTI: '/payroll/safe-rec/rti',
    safeRecRTIHistoryLatest: '/rti/safe-rec-history/latest',
    requestApprover: (id: string) => `/draft-payroll/${id}/request-approval`,
  },
  veriPaye: {
    errors: '/veriPaye/errors',
    manuallySubmit: '/veriPaye/manually-submit',
  },
  import: {
    subcontractor: '/import/excel/subcontractors',
    subcontractorEmployer: '/import/excel/subcontractors/employer',
    xmlSubcontractor: '/import/xml/subcontractors',
    validateXMLSubcontractor: '/import/xml/subcontractors/validate',
    saveXMLSubcontractor: '/import/xml/subcontractors/save',
    agency: '/import/excel/agencies',
    getSub: '/import/excel/get/subcontractors',
    saveImportSub: '/import/excel/subcontractors-save',
    mappingSub: '/import/excel/subcontractors-mapping-file',
    getAgency: '/import/excel/get/agencies',
    mappingAgency: '/import/excel/agencies-mapping-file',
    saveAgency: '/import/excel/agencies-save',
    prospect: '/import/excel/prospect',
    getProspect: '/import/excel/get/prospect',
    mappingProspect: '/import/excel/prospect-mapping-file',
    saveProspect: '/import/excel/prospect-save',
    timeSheet: '/import/excel/timesheet',
    timeSheetBureau: '/import/excel/bureau-timesheet',
    getTimeSheet: '/import/excel/get/timesheet',
    mappingTimeSheet: '/import/excel/timesheet-mapping-file',
    saveTimeSheet: '/import/excel/timesheet-save',
    validateTimeSheet: '/import/excel/validate-with-mapping-template',
    template: '/import/mapping-templates',
    agencyUpload: '/import/agency/upload-file',
  },
  document: {
    main: '/document',
    mainV2: '/v2/document',
  },
  permissions: {
    usersCompany: '/users/admin-company',
    userGroups: '/user-groups',
    editUserCompany: '/users',
    permissions: '/permissions',
    createUserCompany: '/users/admin/create-new-user',
    updateCandidate: '/subcontractor/assign-permissions',
    updateCandidateAll: '/subcontractor/assign-permissions-to-all',
    updateCandidateCompany: '/subcontractor/assign-permissions-by-company',
    updateAgencyAll: '/agency/assign-permissions-to-all',
    candidates: '/v2/subcontractor',
  },
  invoices: {
    main: '/invoice',
    credited: '/invoice/credited',
    create: '/invoice/new-invoice',
    createBureau: '/invoice/new-bureau-invoice',
    edit: '/invoice/edit-invoice',
    sendEmail: '/invoice/send-email',
    sendBureauEmail: '/invoice/send-bureau-email',
    createCreditNote: '/invoice/new-credit-note',
    createCreditNoteBureau: '/invoice/new-bureau-credit-note',
    editCreditNote: '/invoice/edit-credit-note',
    payment: '/invoice/invoice-paid',
    paidAll: '/invoice/invoice-paid-all',
    download: '/invoice/invoice-export-pdf',
    getListTimeSheetFromInvoice: '/invoice/get-list-timesheets-by-invoice',
    invoicePreviewPdf: '/invoice/invoice-pdf-viewer',
    creditNotePreviewPdf: '/invoice/credit-pdf-viewer',
    downloadCreditNotes: '/invoice/credit-export-pdf',
    downloadAllInvoice: '/download-all/invoices',
    downloadAllCredit: '/download-all/credit-no',
    sendInvoiceEmail: '/invoice/raise-invoice/send-mail',
    raiseInvoiceByAgency: '/invoice/raise-invoice/by-agency',
    raiseInvoiceBureau: '/invoice/raise-invoice',
  },
  report: {
    // Attachment Orders is its own domain — not part of pension.
    // Backend moved the endpoint out of the pensions module (NX-5079).
    attachmentOrder: '/attachment-order/reports',
    pension: {
      contributions: '/pensions/reports',
      employeesAssessed: '/v2/subcontractor',
      resubmitError: '/pensions/resubmit-errors',
      submitFromPayrolls: '/pensions/submit-pensions-from-payrolls',
      markSubmitted: '/pensions/mark-many-as-submitted-pension',
      exportNowPension: '/pensions/export-now-pensions',
      exportPensionIreland: '/pensions/reports/ireland/export',
      getAutoEnrollmentStatus: '/pension-assesseds',
      exportPensionAssessed: '/pension-assesseds/export',
      exportPapdisPension: '/pensions/export-papdis-pensions',
      exportPension: '/pensions/export-pensions',
      getScheduleForApprovePayment:
        '/pensions/nest/schedule-for-approve-payment',
      getNestExportPeriod: '/pensions/nest/export-period',
      getSubmissionsForApprovePayment:
        '/pensions/nest/submissions-for-approve-payment',
      approvePayment: (scheduleId: string) =>
        `/pensions/nest/schedule/${scheduleId}/approve-payment`,
    },
    payroll: {
      main: '/payroll',
      paymentSummary: '/report/payment-summary',
      export: '/payroll/export-excel/all',
      email: '/payroll/send-email/subcontractor-self-bill',
      emailManually: '/payroll/send-email/self-bill',
      downloadAll: '/download-all/payrolls',
      draft: '/draft-payroll',
      downloadAllDraft: '/download-all/draft-payrolls',
      holidayPay: '/holiday-pays',
      holidayPaySummary: '/report/payroll/hp-summary',
      pensionExpense: '/payroll/reports',
      dormantWorker: '/subcontractor/dormant-worker-report',
      netPay: '/breakdown-payroll',
      validateDraftBureau: '/draft-payroll/validate-bureau',
      validateDraft: '/draft-payroll/validate',
      assignApprover: '/draft-payroll',
      confirm: '/v2/draft-payroll/confirm/multiple',
      reversalPayroll: '/payroll/reversal-payrolls',
      mainV2: '/v2/payroll',
      fiftyTwoWeekAverageSummary: '/fifty-two-week-payroll-summary',
    },
    reconciliation: {
      unpaidTimeSheet: '/unpaid-timesheet',
      timesheetOnHold: '/timesheet-on-hold',
    },
    management: {
      earning: '/earning-report',
      intermediary: '/intermediary-report',
      earningInSubPortal: '/earning-report/subcontractor',
      earningInSubPortalV2: '/v2/earning-report/subcontractor',
      intermediaryInAgencyPortal: '/intermediary-report/agency',
      exportEarning: '/earning-report/export-pdf',
      exportEarningInSub: '/earning-report/subcontractor/export-pdf',
      sendMultipleMailEarnings: '/earning-report/send-email',
      dormantWorker: '/subcontractor/dormant-worker-report',
    },
    bankFile: {
      main: '/payroll/bank-files/all',
      reDownload: (id: number) => `/payroll/bank-files/${id}/re-download`,
    },
    dormant: {
      main: '/subcontractor/dormant-worker-report',
      validateP45: '/subcontractor/issues-p45/validate',
      p45: '/subcontractor/issues-p45/send-email',
      validateP45BySubcontractorId: (subcontractorId: string) =>
        `/subcontractor/${subcontractorId}/issue-p45/validate`,
      p45BySubcontractorId: (subcontractorId: string) =>
        `/subcontractor/${subcontractorId}/issue-p45/send-email`,
      p45BySubcontractorIdIreland: (subcontractorId: string) =>
        `/subcontractor/${subcontractorId}/issue-p45/ireland`,
      validateP45BySubcontractorIdIreland: (subcontractorId: string) =>
        `/subcontractor/${subcontractorId}/issue-p45/ireland/validate`,
    },
    employee: {
      rtw: '/subcontractors/rtw',
      awr: '/subcontractors/awr',
      wtr: '/subcontractors/wtr',
    },
  },
  rti: {
    fps: '/rti/fps',
    eps: '/rti/eps',
    resubmit: '/hmrc-submitted/fps/re-submit',
    resubmitEPS: '/hmrc-submitted/eps/re-submit',
    manualSubmitEPS: '/dashboard/eps-pre-submit',
    manualSubmitFPS: '/dashboard/payments',
    submitRequestEPS: '/hmrc-submitted/eps',
    submitRequestFPS: '/hmrc-submitted/fps',
    leaverFPS: '/hmrc-submitted/fps/leavers-fps',
    exportAllFPSError: '/rti/fps/export-all-errors',
    exportAllEPSError: '/rti/eps/export-all-errors',
    validateXML: '/hmrc-submitted/validate-xml',
    cis300: '/rti/cis-300',
    deleteCIS300: '/cis-submitted',
    resubmitCIS300: '/cis-submitted/re-submit',
    exportAllCIS300Error: '/rti/cis-300/export-all-errors',
  },
  systemId: {
    main: '/system-id',
  },
  notification: {
    admin: '/notifications',
    employer: '/notifications/employer-all',
    subcontractor: '/notifications/subcontractor-all',
    // NX-5237: the agency has its own feed. Without it an agency user fell
    // through to the admin URL and never saw its own notifications.
    agency: '/notifications/agency-all',
    readAllInAdmin: '/notifications/marked-read-all',
    readAllInEmployer: '/notifications/employer-marked-read-all',
    readAllInSub: '/notifications/subcontractor-marked-read-all',
    readAllInAgency: '/notifications/agency-marked-read-all',
    readByID: '/notifications/marked-read-by-id',
  },
  message: {
    // Kept for recipient search APIs and employee module legacy usage
    all: '/message',
    allCompanyByEmployee: '/subcontractor/company-list',
    employerList: '/users/employers',
  },
  conversation: {
    main: '/conversations',
    detail: (id: number) => `/conversations/${id}`,
    messages: (id: number) => `/conversations/${id}/messages`,
    read: (id: number) => `/conversations/${id}/read`,
    archive: (id: number) => `/conversations/${id}/archive`,
    unarchive: (id: number) => `/conversations/${id}/unarchive`,
    unreadMessages: '/conversations/unread-messages',
    unreadConversationsAndMessages:
      '/conversations/unread-conversations-and-messages',
  },
  hmrc: {
    main: '/HMRC',
    request: '/HMRC/request',
    p6p9: '/HMRC/P6-P9',
    studentLoan: '/HMRC/student-loan',
    p30p32: '/HMRC/P30-P32',
  },
  hmrcRequest: {
    request: {
      auth: '/HMRC/request/auth',
      sync: '/HMRC/request/sync',
      fetch: '/HMRC/request/fetch',
      list: '/HMRC/request',
    },
    P6P9: {
      list: '/HMRC/P6-P9',
      cancel: '/HMRC/P6-P9/cancel',
      apply: '/HMRC/P6-P9/apply',
      applySingle: '/HMRC/P6-P9/apply/single',
    },
    P30P32: {
      detail: '/HMRC/P30-P32',
      saveSettings: '/HMRC/P30-P32/save-settings',
      downloadP30: '/HMRC/P30-P32/download-P30',
      downloadP32: '/HMRC/P30-P32/download-P32',
      downloadStatus: (jobId: number) =>
        `/HMRC/P30-P32/download-status/${jobId}`,
    },
    studentLoan: {
      list: '/HMRC/student-loan',
      cancel: '/HMRC/student-loan/cancel',
      apply: '/HMRC/student-loan/apply',
      applySingle: '/HMRC/student-loan/apply/single',
    },
  },
  prospects: {
    agency: '/prospects/agency',
    candidate: '/prospects/candidate',
    progressCandidate: '/prospects/candidate/progress/subcontractor',
    progressOnboarding: '/prospects/candidate/progress/onboarding',
    progressAgency: '/prospects/agency/progress/agency',
    prospectOnboarding: {
      main: '/prospects',
      bureau: '/prospects/bureau',
      bureauDelete: '/prospects/bureau/delete',
      delete: '/prospects/delete',
      enableOnboarding: '/prospects/enable-onboarding',
      progress: '/prospects/progress',
      yoti: '/user/onboarding/yoti',
      onboarding: '/user/onboarding',
      onboardingV2: '/user/onboarding/v2',
      onboardingNationality: '/user/onboarding/nationality/v2',
      onboardingVerifyId: '/user/onboarding/verify-id-share-code/v2',
      onboardingSuccess: '/user/onboarding/success/v2',
      resend: '/prospects/resend',
      onboardingAdmin: '/user/onboarding/admin',
      updateOnboardingAdmin: '/user/onboarding/ireland/admin',
      createOnboardingAdmin: '/user/onboarding/admin/create',
      onboardingAdminSuccess: '/user/onboarding/admin/success',
    },
    deleteAgency: '/prospects/agency/delete',
  },
  assignments: '/assignment',
  paymentsSetting: {
    payments: '/payment',
    deductions: '/deduction',
  },
  export: '/export-company',
  bulkUpdate: {
    import: '/bulk-update/import/subcontractors',
    save: '/bulk-update/subcontractors-save',
    validate: '/bulk-update/subcontractors-validate',
    main: '/bulk-update',
    importById: (importId: string) => `/bulk-update/${importId}/subcontractors`,
  },
  revenueFilings: {
    psr: '/payroll/psr-submission',
    resubmitPSR: '/payroll/resubmit-psr-submission',
    // NX-6140: one row per POST to Revenue, rather than one per worker.
    psrBatch: '/payroll/psr-submission/batch',
    psrBatchErrors: '/payroll/psr-submission/batch/errors',
    psrBatchDetail: (id: number | string) =>
      `/payroll/psr-submission/batch/${id}`,
    // NX-6140 (BUG-011): what a selection will actually be filed as. The
    // modal used to compose the run reference and line item ids itself, and
    // drifted the moment the backend changed them.
    psrPreview: '/payroll/psr-submission/preview',
  },
  clientApplication: {
    create: '/client/application/create',
    main: '/client/application',
  },
  employment: {
    mainIreland: '/employments/ireland',
    leaver: '/employments/ireland/leaver',
    resubmitLeaver: '/employments/ireland/leaver/resubmit',
    validateLeaverIssues: '/subcontractor/issues-p45/ireland/validate',
    submitLeaverIssues: '/subcontractor/issues-p45/ireland',
  },
  companyParent: {
    base: '/company-parent',
    tags: '/company-parent/tags',
    processYearEnd: '/company-parent/process-year-end',
    currentYearEndProcess: '/company-parent/current-year-end-process',
  },
  statutory: {
    leave: '/statutory',
    payment: '/statutory/records',
    ssp: '/statutory/SSP',
    smp: '/statutory/SMP',
    sap: '/statutory/SAP',
    awe: '/statutory/awe-and-qualifying-week',
    sppa: '/statutory/SPPA',
    spp: '/statutory/SPP',
    stopSsp: '/statutory/stop/SSP',
    resumeSsp: '/statutory/resume/SSP',
    stopSmp: '/statutory/stop/SMP',
    resumeSmp: '/statutory/resume/SMP',
    stopSap: '/statutory/stop/SAP',
    resumeSap: '/statutory/resume/SAP',
    stopSppa: '/statutory/stop/SPPA',
    resumeSppa: '/statutory/resume/SPPA',
    stopSpp: '/statutory/stop/SPP',
    resumeSpp: '/statutory/resume/SPP',
    records: '/statutory/records',
    timesheets: '/statutory/timesheets',
    recordsSMP: '/statutory/records/SMP',
    recordsSAP: '/statutory/records/SAP',
  },
  rpn: {
    main: '/rpn',
    createNew: '/rpn/create-new',
  },
  analytics: {
    payroll: 'analytics/payroll',
    payrollValues: 'analytics/payroll-values',
    registration: 'analytics/registration',
    registrationNew: 'analytics/registration/new',
    registrationPending: 'analytics/registration/pending',
    registrationList: 'analytics/registration/list',
    pay: 'analytics/value-pay',
    invoicing: 'analytics/invoicing',
    invoicingValues: 'analytics/invoicing-values',
    invoicingValuesList: 'analytics/invoicing-values/list',
    payments: 'analytics/payments',
    paymentsList: 'analytics/payments/list',
    paymentsTaxPeriod: 'analytics/payments/tax-period',
    employeeStatus: 'analytics/employee-status',
    agency: 'analytics/agency',
    agencyInvoice: 'analytics/agency/invoice',
    companiesNoPayrollList: 'analytics/companies-no-payroll/list',
    pensionDocument: 'analytics/pension-document',
    pensionDocumentList: 'analytics/pension-document/list',
    payrollCost: 'analytics/payroll-cost',
    payrollCostList: 'analytics/payroll-cost/list',
    requiredAlerts: 'analytics/required-alerts',
    requiredAlertsList: 'analytics/required-alerts/list',
    payslipsProcessed: 'analytics/payslips/processed',
    payslipsProcessedList: 'analytics/payslips/processed/list',
    // Overviews/aggregates
    payslipsProcessedOverview: 'analytics/payslips/processed/overview',
    activePayrollRun: 'analytics/active-payroll-run',
    payrollRunTasks: 'analytics/payroll-run-tasks',
  },
  banner: {
    main: '/banner',
  },
  urgentActions: {
    summary: '/admin/urgent-actions/summary',
    main: '/admin/urgent-actions',
    snooze: '/admin/urgent-actions/snooze',
  },
  billing: {
    accountCode: '/billing/account-code',
    me: '/billing/me',
    access: '/billing/access',
    accessMember: (userId: string) => `/billing/access/${userId}`,
    months: '/billing/months',
    grid: (month: string) => `/billing/months/${month}/grid`,
    clients: '/billing/clients',
    client: (id: string) => `/billing/clients/${id}`,
    clientFollow: (id: string) => `/billing/clients/${id}/follow`,
    clientHistory: (id: string) => `/billing/clients/${id}/history`,
    clientCustomise: (id: string) => `/billing/clients/${id}/customise`,
    clientMinimum: (id: string) => `/billing/clients/${id}/minimum`,
    clientCharge: (id: string, chargeTypeId: string) =>
      `/billing/clients/${id}/charges/${chargeTypeId}`,
    clientQuantity: (id: string, month: string, chargeTypeId: string) =>
      `/billing/clients/${id}/quantities/${month}/${chargeTypeId}`,
    oneOffs: (id: string) => `/billing/clients/${id}/one-offs`,
    oneOff: (id: string, oneOffId: string) =>
      `/billing/clients/${id}/one-offs/${oneOffId}`,
    preview: (id: string) => `/billing/clients/${id}/preview`,
    bulk: '/billing/clients/bulk',
    companies: (id: string) => `/billing/clients/${id}/companies`,
    company: (id: string, system: string, companyId: string) =>
      `/billing/clients/${id}/companies/${system}/${companyId}`,
    dismissSuggestion: '/billing/link-suggestions/dismiss',
    settings: '/billing/settings',
    invoiceSettings: '/billing/settings/invoice',
    chargeTypes: '/billing/charge-types',
    chargeType: (id: string) => `/billing/charge-types/${id}`,
    tierSets: '/billing/tier-sets',
    tierSet: (id: string) => `/billing/tier-sets/${id}`,
    priceLists: '/billing/price-lists',
    priceList: (id: string) => `/billing/price-lists/${id}`,
    priceListCharge: (id: string, chargeTypeId: string) =>
      `/billing/price-lists/${id}/charges/${chargeTypeId}`,
    changes: '/billing/changes',
    undoChange: (changeSetId: string) =>
      `/billing/changes/${changeSetId}/undo`,
    exports: '/billing/exports',
    exportDownload: (id: string) => `/billing/exports/${id}/download`,
    exportCancel: (id: string) => `/billing/exports/${id}/cancel`,
    exportPreview: (month: string) =>
      `/billing/months/${month}/export-preview`,
  },
  internalReport: {
    main: '/internal-report',
    smartPension: '/internal-report/smart-pension',
    note: '/internal-report/note',
  },
  expenses: {
    main: '/expenses',
    approve: '/expenses/approve',
    reject: '/expenses/reject',
  },
  aepn: {
    main: '/naersa/aepn',
    upload: '/naersa/aepn/upload',
    uploadSave: '/naersa/aepn/upload/save',
    uploadHistory: '/naersa/aepn/upload/history',
    download: '/naersa/aepn/download',
    downloadForEmployee: '/naersa/aepn/download/subcontractor',
    downloadForCompany: '/naersa/aepn/download/company',
    payrollPending: '/naersa/aepn/payroll/pending',
    contributionsHistory: '/naersa/contributions/history',
    contributionsSubmit: '/naersa/contributions/submit',
    contributionsResubmit: '/naersa/contributions/resubmit',
    contributionsStatus: '/naersa/contributions/status',
    contributionsErrors: '/naersa/contributions/errors',
    contributionsExport: '/naersa/contributions/export',
  },
  ai: {
    chatStream: '/ai/chat/stream',
    chat: '/ai/chat',
    sessions: '/ai/sessions',
    session: (id: string) => `/ai/sessions/${id}`,
    sessionFeedback: (id: string) => `/ai/sessions/${id}/feedback`,
    chatConfig: '/ai/chat-config',
    dailyGreeting: '/ai/daily-greeting',
    tickets: '/ai/tickets',
    admin: {
      sessions: '/ai/admin/sessions',
      session: (id: string) => `/ai/admin/sessions/${id}`,
      stats: '/ai/admin/stats',
      export: '/ai/admin/export',
    },
  },
  // NX-4971 — Payslip Verifier (Penny) cross-tenant super-admin monitoring.
  // NX-6317 — super-admin Internal tools tab (/manage-account/tools)
  internalTools: {
    searchSubcontractors: '/internal-tools/search/subcontractors',
    searchCompanies: '/internal-tools/search/companies',
    passwordSyncLookup: '/internal-tools/password-sync/lookup',
    passwordSync: '/internal-tools/password-sync',
    payFrequency: (subcontractorId: string) =>
      `/internal-tools/pay-frequency/${encodeURIComponent(subcontractorId)}`,
    twoFactorReset: '/internal-tools/two-factor-reset',
    missedMonthlyFps: '/internal-tools/missed-monthly-fps',
    nestOptOuts: '/internal-tools/nest-opt-outs',
    smartPensionWrongPeriod: '/internal-tools/smart-pension-wrong-period',
    selfBillPdf: '/internal-tools/self-bill-pdf',
    taxDocuments: '/internal-tools/tax-documents',
  },
  payslipVerifier: {
    admin: {
      list: '/payslip-verifier/admin/verifications',
      stats: '/payslip-verifier/admin/stats',
    },
  },
  publicDraft: {
    get: (token: string) => `/public/company-draft/${token}`,
    update: (token: string) => `/public/company-draft/${token}`,
    connectNest: (token: string) =>
      `/public/company-draft/${token}/nest/connect`,
    preAuthorizeSmartPension: (token: string) =>
      `/public/company-draft/${token}/smart-pension/pre-authorize`,
    pensionStatus: (token: string) =>
      `/public/company-draft/${token}/pension/status`,
    submit: (token: string) => `/public/company-draft/${token}/submit`,
    bankNames: (token: string) => `/public/company-draft/${token}/bank-names`,
  },
  payrollOverview: {
    listing: '/payroll-overview',
    detail: (companyId: string) => `/payroll-overview/${companyId}`,
  },
  // NX-5235 — Xero payroll journal export
  accounting: {
    journalPreview: '/accounting/journal/preview',
    journalExport: '/accounting/journal/export',
  },
  umbrellaRateCalculator: {
    calculate: '/umbrella-rate-calculator/calculate',
    rateConfigs: '/app-configs/rates',
  },
};
